import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest
} from "@/Utils/Service/BackendService";

import {
	Report,
	ReportsResponse,
	ReportConfig,
	CreateReportFormState,
	ReportsListRequest
} from "@/Contracts/Reports/Reports.contract";
import { DeletedRecord } from "@/Contracts";

const getReportsUrl = "/v2/reports";
const createReportsUrl = "/v2/reports";
const editReportUrl = "/v2/reports/{report_id}?include_report_data=true";
const deleteReportUrl = "/v2/reports/{report_id}";
const getReportsConfigUrl = "/v2/reports/config";
const getReportDetailsUrl = "/v2/reports/{report_id}?include_report_data=true";

const createReportPreviewUrl = "/v2/reports/preview?include_report_data=true";

export const getReports = async (
	paginationParams?: ReportsListRequest
): Promise<ReportsResponse> => {
	try {
		let url = `${getReportsUrl}`;
		if (paginationParams) {
			url += `?page=${paginationParams.page}&limit=${paginationParams.limit}`;
		}
		const response: AxiosResponse<ReportsResponse> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

// export const searchReports = async (reportsRequest: ReportsRequest): Promise<ReportsResponse> => {
// 	try {
// 		let url = searchReportsUrl;
// 		if (reportsRequest.filters.length > 0) {
// 			const appliedFilters = getTableQueryFilters(reportsRequest.filters, false);
// 			url = url + '?' + appliedFilters;
// 		}
// 		const separator = reportsRequest.filters.length > 0 ? '&' : '?';
// 		url =
// 			url +
// 			`${separator}item_source=` +
// 			(reportsRequest.item_source && reportsRequest.item_source.length > 0
// 				? reportsRequest.item_source
// 				: ReportSource.Self);
// 		if (reportsRequest.keywords && reportsRequest.keywords.length > 0) {
// 			url = url + `&q=${reportsRequest.keywords}`;
// 		}
// 		if (reportsRequest.cursor && reportsRequest.cursor.length > 0) {
// 			url = url + `&next=${reportsRequest.cursor}`;
// 		}
// 		const response: AxiosResponse<ReportsResponse> = await axios(
// 			getRequest(url, null, true, false, false)
// 		);
// 		return response.data;
// 	} catch (error) {
// 		return Promise.reject(error);
// 	}
// };

export const deleteReport = async (
	reportId: string
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteReportUrl.replace("{report_id}", reportId),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

// export const addReport = async (addReportRequest: AddReportRequest): Promise<Report> => {
// 	try {
// 		const response: AxiosResponse<Report> = await axios(
// 			postRequest(addReportUrl, addReportRequest, true, false, false)
// 		);
// 		return response.data;
// 	} catch (error) {
// 		return Promise.reject(error);
// 	}
// };

export const editReport = async (
	report: Partial<Omit<Report, "id">> & Pick<Report, "id">
): Promise<Report> => {
	try {
		const response: AxiosResponse<Report> = await axios(
			putRequest(
				editReportUrl.replace("{report_id}", report.id),
				report,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getReportDetails = async (reportId: string): Promise<Report> => {
	try {
		const response: AxiosResponse<Report> = await axios(
			getRequest(
				getReportDetailsUrl.replace("{report_id}", reportId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCreateReportConfig = async (): Promise<ReportConfig> => {
	try {
		const response: AxiosResponse<ReportConfig> = await axios(
			getRequest(getReportsConfigUrl, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createReportPreview = async (
	createReportData: CreateReportFormState
): Promise<Report> => {
	try {
		const response: AxiosResponse<Report> = await axios(
			postRequest(
				createReportPreviewUrl,
				createReportData,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createReport = async (
	createReportData: CreateReportFormState
): Promise<Report> => {
	try {
		const response: AxiosResponse<Report> = await axios(
			postRequest(createReportsUrl, createReportData, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
